<template>
    <content-link-create :client-id="clientId" :back-route="{ name: 'client-content-links', params: { clientId: clientId } }" />
</template>
<script>
import ContentLinkCreate from '../../../../common/content/link/content-link-create.vue'

export default {
    name: 'system-content-links-create',
    components: { ContentLinkCreate },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/content/links/create.vue